import React, { useContext } from 'react';
import { GameDataContext } from '../providers/GameDataProvider';
import { CommunityDragonContext } from '../providers/CommunityDragonProvider';
import Rank from './Rank';
import { Team } from '../types/snapshot/Enums';
import { getAggregatedEvents, getRanks, getWinrateContributions } from '../utils/utils';
import PositionTop from '../icons/position_top.png';
import PositionJungle from '../icons/position_jungle.png';
import PositionMid from '../icons/position_mid.png';
import PositionBot from '../icons/position_bot.png';
import PositionSupport from '../icons/position_support.png';
var positionIcons = [PositionTop, PositionJungle, PositionMid, PositionBot, PositionSupport];
var WinrateContributionRanks = function () {
    var _a;
    var gameData = useContext(GameDataContext);
    var championSummary = useContext(CommunityDragonContext).championSummary;
    if (!gameData) {
        return null;
    }
    var containerStyle = {
        position: 'relative',
        width: 70,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    };
    var headerStyle = {
        position: 'absolute',
        top: 10,
        left: '50%',
        transform: 'translate(-50%, -100%)',
        fontSize: 12,
        fontWeight: 500,
        paddingBottom: 10,
    };
    var championId = (_a = championSummary === null || championSummary === void 0 ? void 0 : championSummary.find(function (champion) { return champion.alias.toLowerCase() === gameData.playerChampion; })) === null || _a === void 0 ? void 0 : _a.id;
    var championIcon = championId ? "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/champion-icons/".concat(championId, ".png") : gameData.playerChampion;
    var position = [gameData.allyRoles.top, gameData.allyRoles.jungle, gameData.allyRoles.mid, gameData.allyRoles.bot, gameData.allyRoles.support].indexOf(gameData.playerChampion);
    var positionIcon = positionIcons[position];
    var aggEvents = getAggregatedEvents(gameData.events);
    var winrateContributions = getWinrateContributions(aggEvents, gameData.allyRoles, gameData.playerTeam);
    var playerRanks = getRanks(winrateContributions, gameData.playerChampion);
    return (React.createElement("div", { style: { width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
        React.createElement("div", { style: { width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' } },
            React.createElement("div", { style: { position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', marginTop: 35, marginBottom: 70, paddingTop: 20 } },
                championIcon.endsWith('.png') ?
                    React.createElement("img", { src: championIcon, alt: gameData.playerChampion, style: { width: 50, height: 50, border: "2px solid ".concat(gameData.playerTeam === Team.BLUE ? 'rgb(0, 163, 240, 0.8)' : 'rgb(230, 10, 20, 0.8)'), borderRadius: '50%', boxSizing: 'content-box' }, draggable: false })
                    :
                        React.createElement("div", null, gameData.playerChampion),
                React.createElement("img", { src: positionIcon, style: { width: 50, height: 50, marginLeft: 20 }, draggable: false }),
                gameData.playerRiotId &&
                    React.createElement("div", { style: { position: 'absolute', width: '100%', top: 0, left: '50%', transform: 'translate(-50%, -100%)', fontSize: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', textWrap: 'nowrap' } }, gameData.playerRiotId)),
            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                React.createElement("div", { style: containerStyle },
                    React.createElement("div", { style: headerStyle }, "Overall"),
                    React.createElement(Rank, { rank: playerRanks.overall })),
                React.createElement("div", { style: containerStyle },
                    React.createElement("div", { style: headerStyle }, "Impact"),
                    React.createElement(Rank, { rank: playerRanks.gameImpact })),
                React.createElement("div", { style: containerStyle },
                    React.createElement("div", { style: headerStyle }, "Deaths"),
                    React.createElement(Rank, { rank: playerRanks.deaths }))))));
};
export default WinrateContributionRanks;
